import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import MainApp from './pages/MainApp';
import PrivateRoute from './components/PrivateRoute';
import { useAuth } from './context/AuthContext';


console.log("Backend API URL:", process.env.REACT_APP_BACKEND_API_URL);

function App() {
  const { authChecked } = useAuth(); // Get auth state from context

  if (!authChecked) {
    return <p>Checking authentication...</p>; // Wait for auth state to be checked
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainApp />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;

